import React from 'react';
import AgeLimit from 'components/AgeLimit/AgeLimit';
import VisualEffect from 'components/VisualEffect/VisualEffect';
import PropTypes from 'prop-types';


const TableTitle = ({ title, agelimit, href, dubSubCodes, visualEffects, brandClass }) => (
  <td className={`react-movie-table-data react-mozi-brand ${brandClass}`}>
    <div className="react-movie-table-container">
      <div className="react-movie-table-title-container">
        <a className="react-movie-table-movie-title" href={href} onClick={() => window.location.assign(href)}>
          {title}
        </a>
        {dubSubCodes ? dubSubCodes.map(dubsubCode => (
          <div key={dubsubCode} className="react-movie-table-movie-dubsub">{dubsubCode !== null ? `(${dubsubCode})` : ''}</div>
        )) : null}
      </div>
      <div className={`react-movie-table-link-container${visualEffects.length > 1 ? ' row-wrap' : ''}`}>
        <div className="react-movie-table-movie-age-limit">
          <AgeLimit age={agelimit} />
        </div>
        <div className="react-movie-table-movie-visual-effect-container">
          {visualEffects.map(visualEffect => (
            <div key={visualEffect} className="react-movie-table-movie-visual-effect"><VisualEffect effect={visualEffect} /></div>
          ))}
        </div>
      </div>
    </div>
  </td>
);

TableTitle.propTypes = {
  title: PropTypes.string.isRequired,
  agelimit: PropTypes.string,
  brandClass: PropTypes.string,
  href: PropTypes.string.isRequired,
  dubSubCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  visualEffects: PropTypes.arrayOf(PropTypes.string).isRequired,
};

TableTitle.defaultProps = {
  agelimit: null,
  brandClass: 'react-artmozi',
};

export default TableTitle;
